const translateMonths = {
  Январь: {
    name: 'January',
  },
  Февраль: {
    name: 'February',
  },
  Март: {
    name: 'March',
  },
  Апрель: {
    name: 'April',
  },
  Май: {
    name: 'May',
  },
  Июнь: {
    name: 'June',
  },
  Июль: {
    name: 'July',
  },
  Август: {
    name: 'August',
  },
  Сентябрь: {
    name: 'September',
  },
  Октябрь: {
    name: 'October',
  },
  Ноябрь: {
    name: 'November',
  },
  Декабрь: {
    name: 'December',
  },
};

export default translateMonths;
